"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var sendInstructions = function (email, resource) {
    if (resource === void 0) { resource = 'User'; }
    return Request.sendPost(constants_1.endpoints.api + "/passwords", {
        email: email,
        resource_type: resource,
    });
};
exports.sendInstructions = sendInstructions;
var reset = function (token, password, confirmation, resource) {
    if (resource === void 0) { resource = 'User'; }
    return Request.sendPut(constants_1.endpoints.api + "/passwords", {
        reset_password_token: token,
        password: password,
        password_confirmation: confirmation,
        resource_type: resource,
    });
};
exports.reset = reset;
//# sourceMappingURL=password.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/password.js
// module id = 909
// module chunks = 3